import React from 'react'
import Title from '../../../../components/typography/title.component'
import moment from 'moment'
import Container from '../../../../components/layout/container.component'
import SearchForm from './components/search-form.component'
import ReactTooltip from 'react-tooltip'
import PointsInformation from '../components/points-information.component'
import AccordionSecondary from '../../../../components/accordion/accordion-secondary.component'
import PaginationComponent from '../../../../components/pagination/pagination.component'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { toastActions } from '../../../../actions'
import { ClientService } from '../../../../services/client.service'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../../../ducks/site/site'

class ClientExtractOfPointsComponent extends React.Component {
	constructor(props) {
		super(props)

		this.renderRow = renderRow.bind(this)

		this.state = {
			initialDate: '',
			finalDate: '',
			type: '',
			dataTip: ''
		}
	}

	handleSubmit = ({ initialDate, finalDate, transactionType }) => {
		const { warning } = this.props
		const momentInitialDate = moment(initialDate, 'YYYY-MM-DD')
		const momentFinalDate = moment(finalDate, 'YYYY-MM-DD')

		this.params = { initialDate, finalDate }

		if (momentFinalDate.isAfter(moment())) {
			warning({
				message: 'A data final não pode ser maior que a data atual'
			})
			return
		}

		if (momentInitialDate.isAfter(momentFinalDate)) {
			warning({
				message: 'A data inicial não pode ser maior que a data final'
			})
			return
		}

		const momentMinDate = moment()
			.subtract(60, 'months')
			.subtract(1, 'days')
		if (momentInitialDate.isBefore(momentMinDate)) {
			warning({
				message: 'O período máximo para consulta de extrato é de 60 meses'
			})
			return
		}

		this.setState(
			{
				initialDate,
				finalDate,
				type: transactionType === 'none' ? '' : transactionType
			},
			() => this.refs.pagination.reload()
		)
	}

	getAccordionItems = () => [
		{
			title: 'Filtros',
			content: (
				<SearchForm
					ref={'form'}
					onSubmit={this.handleSubmit}
					params={this.params}
				/>
			)
		}
	]

	render() {
		const { initialDate, finalDate, type, dataTip } = this.state
		return (
			<Container>
				<Title>Extrato de Pontos</Title>
				<PointsInformation />
				<AccordionSecondary
					arrow={false}
					multiple={false}
					noClickable
					noAnimated
					items={this.getAccordionItems()}
				/>
				<PaginationComponent
					dataTip={dataTip}
					ref={'pagination'}
					getData={ClientService.getExtractOfPoints}
					headers={paginationHeaders}
					params={{ initialDate, finalDate, type }}
					rowsPerPage={50}
					sortable={paginationSortable}
					renderRow={this.renderRow}
					loadonce
				/>
				<ReactTooltip
					getContent={() => dataTip}
					type={'warning'}
					html={true}
				/>
			</Container>
		)
	}
}

function renderRow(rowData, headers) {
	const onMouseEnter = () => {
		const { trackNumber, tripDate, price } = rowData.extra || {}

		const dataTip = rowData.extra
			? `
			<p>
				Localizador: ${trackNumber}
				<br />
				Data da viagem: ${tripDate}
				<br />				
				Valor: ${price.$toReais()}
			</p>`
			: ''

		this.setState({
			dataTip
		})
	}

	return headers.map(({ key, align }) => (
		<td onMouseEnter={onMouseEnter} key={key} align={align}>
			<span
				title={rowData[key]}
				className={
					key == 'value'
						? `${rowData['isCredit'] ? 'blue' : 'danger'}`
						: ''
				}>
				{key == 'value'
					? Number(rowData[key]).toLocaleString('pt-BR')
					: rowData[key]
						? rowData[key]
						: ''}
			</span>
		</td>
	))
}

const paginationHeaders = [
	{ header: 'Data transação', key: 'date' },
	{ header: 'Tipo', key: 'type' },
	{ header: 'Parceiro', key: 'broker' },
	{ header: 'Produto', key: 'notes' },
	{ header: 'Pontos', key: 'value', align: 'right' },
	{ header: 'Data de vencimento', key: 'expirationDate', align: 'center' }
]

const paginationSortable = {
	defaultOrder: 'desc',
	cols: [
		{ key: 'date' },
		{ key: 'type' },
		{ key: 'value' },
		{ key: 'expirationDate' }
	]
}

const mapStateToProps = ({ toast, client }) => ({
	...toast,
	...client
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			...SiteCreators,
			...toastActions
		},
		dispatch
	)

const connectedClientExtractOfPointsComponent = withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(ClientExtractOfPointsComponent)
)

export { connectedClientExtractOfPointsComponent as ModuleRootComponent }
